/* eslint-disable max-len */

import IlvQuestion from 'images/coin-pages/questions/ilv.svg'

import { ICoinPageData } from '../types'

export const ilvPage: ICoinPageData = {
  title: 'coin_503',
  description: 'coin_504',
  questionsBlock: {
    image: IlvQuestion,
    questions: [
      {
        title: 'coin_505',
        answer: 'coin_506',
      },
      {
        title: 'coin_507',
        answer: 'coin_508',
      },
      {
        title: 'coin_509',
        answer: 'coin_510',
      },
      {
        title: 'coin_511',
        answer: 'coin_512',
      },
      {
        title: 'coin_513',
        answer: 'coin_514',
      },
    ],
  },
  whatIs: {
    text: ['coin_519'],
    paragraphs: [
      {
        title: 'coin_515',
        text: ['coin_520'],
      },
      {
        title: 'coin_516',
        text: ['coin_521'],
      },
      {
        title: 'coin_517',
        text: ['coin_522', 'coin_523', 'coin_524', 'coin_525'],
      },
      {
        title: 'coin_518',
        text: ['coin_526', 'coin_527', 'coin_528', 'coin_529', 'coin_530'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/what-is-crypto-lending-and-how-does-it-work/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/07/photo_2021-07-23_20-28-31.jpg',
        imageAlt: 'Illuvium (ILV) review 5',
      },
      {
        link: 'https://coinrabbit.io/blog/how-crypto-assets-are-secured/',
        image: 'https://coinrabbit.io/blog/wp-content/uploads/2021/08/integration-52CR_LQ.png',
        imageAlt: 'Illuvium (ILV) review 6',
      },
      {
        link: 'https://coinrabbit.io/blog/guide-to-short-selling-with-coinrabbit-bear-market-loans/',
        image: 'https://coinrabbit.io/blog/wp-content/uploads/2021/06/Bear-loans.png',
        imageAlt: 'Illuvium (ILV) review 7',
      },
    ],
  },
}
